import { useI18n } from "i18n";
import classNames from "classnames";
import { VideoAudioTestView } from "modules/micCamCheck/components/VideoAudioTestView";
import { useStyles as useMicCamCheckStyles } from "modules/micCamCheck/components/MicCamCheckView";
import { AppCircleLogo } from "modules/app/branding";
import { GeartestContext } from "modules/micCamCheck/types";
import { PAGES, usePageTracking } from "modules/tracking";
import CameraSettingsContainer from "modules/cameraSettings/CameraSettingsContainer";
import { ScrollableView } from "@remo-co/ui-core/src/components/ScrollableView";
import { AppBar } from "@remo-co/ui-core/src/components/AppBar";
import { Toolbar } from "@remo-co/ui-core/src/components/Toolbar";
import { Alert } from "@remo-co/ui-core/src/components/Alert";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { useStyles } from "./styles";

export const GearTestPage = (): JSX.Element => {
  const { overflowYAuto, mlAuto, geartestContainer, geartestAlert } =
    useStyles();
  const { micCamCheckContainer } = useMicCamCheckStyles();
  const { t } = useI18n(["micCamCheck"]);

  usePageTracking(PAGES.PUBLIC_GEARTEST);

  return (
    <ScrollableView className={overflowYAuto}>
      <div className="app-bar-style">
        <AppBar position="static">
          <Toolbar>
            <div className={mlAuto}>
              <AppCircleLogo />
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <Alert severity="info" className={geartestAlert}>
        {t("page.is.only.for.testing")}
      </Alert>
      <Container
        className={classNames(geartestContainer, micCamCheckContainer)}
      >
        <VideoAudioTestView context={GeartestContext.public} />
      </Container>
      <CameraSettingsContainer />
    </ScrollableView>
  );
};
